// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import App from './App';

// Merge awsExports, but force returnSession: true so that
// fetchAuthSession({ provider: 'userPoolTokens' }) includes tokens
Amplify.configure({
  ...awsExports,
  Auth: {
    ...awsExports.Auth,
    // Ensure Amplify returns the full Cognito session (with tokens)
    returnSession: true
  }
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
